import { useLocation } from "react-router-dom"
import { ContactIcon, PencilIcon, UserIcon } from "../../../icons"
import { Button } from "../../ui/Button"
import { useEffect, useState } from "react";
import { ArrowRight } from "../../../icons/arrowRight";

export const DocumentOptions = ({ setUserSelection, cncode , setContinueSalesperson, continueSalesperson, salesPersonFlow }) => {
    const [error, setError] = useState(false)

    const location = useLocation();

    useEffect(() => {
        if (location && location.state) {
            if (location.state.status === 'failed') {
              setError(true)
            }
          }
    },[location])
    return (
    <>
        {
                salesPersonFlow && !continueSalesperson ? 
                <div className="max-lg:p-5 lg:left-[480px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[130px] flex flex-col  gap-6 lg:gap-10 pb-10">
                <h2>Πώς επιθυμείς να προχωρήσεις;</h2>
                <div
                    className="lg:container lg:mx-auto bg-white rounded-[12px] p-5 lg:p-10 gap-6 flex flex-col lg:shadow-md max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
                    <div className="flex gap-2 items-center flex">
                        <UserIcon className={'stroke-black fill-none w-[25px] h-[25px]'} />
                                <h3>Θα επικοινωνήσουμε σύντομα μαζί σου</h3>
                            </div>
                    <p>Ένας Σύμβουλος Πωλήσεων θα επικοινωνήσει μαζί σου σύντομα για την ολοκλήρωση της διαδικασίας.</p>
                </div>
                <div
                    className="lg:container lg:mx-auto  bg-white rounded-[12px] p-5 lg:p-10 gap-6 flex flex-col lg:shadow-md max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
                    <div className="flex gap-2 items-center flex">
                        <ArrowRight/>
                        <h3>Ολοκλήρωσε με online leasing</h3>
                    </div>
                    <p>Η προσφορά σου έχει ήδη διαμορφωθεί και μπορείς να ολοκληρώσεις online όλα τα επόμενα βήματα εύκολα και γρήγορα.</p>
                    <div className="w-full flex justify-end">
                        <Button onClick={() => {setContinueSalesperson(true)}} className="text-white bg-[#D4002A] py-3 px-10 rounded-[6px] max-lg:w-full">Επόμενο</Button>
                    </div>
                </div>
            </div>
                :
                <div className="max-lg:p-5 lg:left-[480px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[130px] flex flex-col  gap-6 lg:gap-10 pb-10">
                    <h2>Πώς επιθυμείς να ενημερώσεις τα στοιχεία του λογαριασμού σου;</h2>
                    {error &&
                        <div className="p-4 bg-[#FFD5D5] rounded-[12px]">
                           Προέκυψε σφάλμα κατά τη σύνδεσή σου στο Gov.gr, προσπάθησε ξανά.
                        </div>}
                    <div
                        className="lg:container lg:mx-auto  bg-white rounded-[12px] p-5 lg:p-10 gap-6 flex flex-col lg:shadow-md max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
                        <div className="flex gap-2 items-center flex">
                            <PencilIcon className={'stroke-black'} />
                            <h3>Υποβολή στοιχείων & εγγράφων</h3>
                        </div>
                        <p>Με την επιλογή αυτή, θα σου ζητηθεί να συμπληρώσεις τη Φόρμα Νέου Πελάτη και να ανεβάσεις όλα τα απαραίτητα έγγραφα πιστοποίησης.</p>
                        <div className="w-full flex justify-end">
                            <Button className="text-white bg-[#D4002A] py-3 px-10 rounded-[6px] max-lg:w-full" onClick={() => { setUserSelection(true) }}>Επόμενο</Button>
                        </div>
                    </div>
                    <div
                        className="lg:container lg:mx-auto  bg-white rounded-[12px] p-5 lg:p-10 gap-6 flex flex-col lg:shadow-md max-lg:border max-lg:border-[#A5A5A5] max-lg:rounded-[12px]">
                        <div className="flex gap-2 items-center flex">
                            <img width={40} height={40} alt="" src="/avis/images/govIcon.png" className={'stroke-black'} />
                            <h3>Μέσω της υπηρεσίας «Συστηθείτε-Know Your Customer»</h3>
                        </div>
                        <p>Η υπηρεσία «Συστηθείτε-Know Your Customer» (eGov-KYC) είναι μια ψηφιακή εναλλακτική για να ολοκληρώσεις εύκολα και γρήγορα τη διαδικασία υποβολής στοιχείων και εγγράφων, καθώς αντλεί τα στοιχεία σου σε πραγματικό χρόνο από το μητρώο της Γενικής Γραμματείας Πληροφοριακών Συστημάτων, μετά τη συγκατάθεσή σου.</p>
                        <div className="w-full flex justify-end">
                            <Button onClick={() => {
                                window.open(`${process.env.REACT_APP_KYC_URL}/oauth?response_type=code&state=${cncode}&client_id=${process.env.REACT_APP_KYC_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_BASE_URL}/KYC/callback&lang=el&scope=identity%20income%20contactInfo%20professionalActivity`,"_self")
                            }} className="text-white bg-[#D4002A] py-3 px-10 rounded-[6px] max-lg:w-full">Επόμενο</Button>
                        </div>
                    </div>
                </div>
            }
            </>
    )
}